import { usePatch } from 'hooks/usePatch'
import { ScheduleType, SchoolSpecialityClassification } from './type'

export type UpdateResponseBody = {
  schedule: { id: string }
}

export type UpdateErrorResponse = {
  errors: {
    campaignId?: string[],
    type?: string[],
    onlineText?: string[],
    prefectureId?: string[],
    postcode?: string[],
    city?: string[],
    building?: string[],
    station?: string[],
    isSchedule?: string[],
    noScheduleText?: string[],
    startAt?: string[],
    endAt?: string[],
    isPublished?: string[],
    publicStartAt?: string[],
    publicEndAt?: string[],
    participantLimit?: string[],
    remarks?: string[],
    areaId?: string[],
    targetPrefectureIds?: string[],
    targetSpecialtyClassifications?: string[]
  }
}

export type UpdateRequestBody = {
  schedule: {
    type: ScheduleType,
    onlineText: string,
    prefectureId: string,
    postcode: string,
    city: string,
    building: string,
    station: string,
    isSchedule: boolean,
    noScheduleText: string,
    startAt: string,
    endAt: string,
    isPublished: boolean,
    publicStartAt: string,
    publicEndAt: string,
    participantLimit?: number,
    remarks?: string
    areaId: string,
    targetPrefectureIds: string[],
    targetSpecialityClassifications: SchoolSpecialityClassification[]
  }
}

export const useUpdateSchedules = (campaignId: string, scheduleId: string) => {
  const path = `api/v1/admin/campaigns/${campaignId}/schedules/${scheduleId}`
  return usePatch<UpdateRequestBody>(path)
}
